import { getDomain } from '@helpers/domain.helper';

const Contacts = () => {
  return (
    <section>
      <div className="container bs-docs-container">
        <h1 className="mt-2 mb-3">Походники Пензы. @pohodnik58</h1>
        <ul className="list-group mb-4">
          <a
            href="https://www.youtube.com/c/%D0%9F%D0%BE%D1%85%D0%BE%D0%B4%D0%BD%D0%B8%D0%BA%D0%B8"
            className="list-group-item list-group-item-action"
          >
            <button
              className="btn btn-danger btn-sm float-end pull-right"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                location.href = 'https://bit.ly/poh58YS';
              }}
            >
              Подписаться
            </button>
            YouTube-канал Походники
          </a>
          <a href="https://vk.com/pohodnik58" className="list-group-item list-group-item-action">
            Группа VK /pohodnik58
          </a>
          <a href="https://vk.com/poh58" className="list-group-item list-group-item-action">
            VK @poh58
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=100008154401536"
            className="list-group-item list-group-item-action"
          >
            facebook Походники Пензы
          </a>
          <a
            href="https://pohodnik58.livejournal.com/"
            className="list-group-item list-group-item-action"
          >
            ЖЖ pohodnik58.livejournal.com
          </a>
          <a
            href="https://twitter.com/pohodnik58"
            className="list-group-item list-group-item-action"
          >
            twitter @pohodnik58
          </a>
          <a
            href="https://www.instagram.com/pohodnik58/"
            className="list-group-item list-group-item-action"
          >
            instagram: @pohodnik58
          </a>
          <a
            href="https://www.strava.com/clubs/448945"
            className="list-group-item list-group-item-action"
          >
            Клуб в Strava
          </a>
          <a
            href="https://www.strava.com/athletes/19338014"
            className="list-group-item list-group-item-action"
          >
            Участник в Strava
          </a>
          <a
            href="https://github.com/pohodnik58"
            className="list-group-item list-group-item-action"
          >
            github pohodnik58
          </a>
          <a href={`https://${getDomain()}`} className="list-group-item list-group-item-action">
            Сайт {getDomain()}
          </a>
        </ul>
        <footer>
          <p>
            <img
              src={`//${getDomain()}/assets/img/svg/pohColor.svg`}
              width="24"
              className="pull-left"
            />{' '}
            &copy; pohodnik58 2014 - 2026
          </p>
        </footer>
      </div>
    </section>
  );
};

export default Contacts;
